import React from "react";
import styles from "./Loader.module.scss";

export default function Loader() {
  return (
    <section className={styles.loader_main}>
      <div className={styles.loader_sec}>
        <video width="100%" height="100%" autoPlay loop muted playsInline>
          <source src="/video/loader.mp4" type="video/mp4" />
        </video>
      </div>
    </section>
  );
}
